<section>
  <h1>Adicione um endereço como principal</h1>
  <ng-lottie width="30vh" height="30vh" [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
</section>
